<template>
  <Timeline
    :pt="{
      opposite: {
        class: 'hidden'
      },
      content: {
        class: 'pl-4 pr-0'
      },
      marker:({ context }) => ({
        class: [
          'transition-all duration-300',
          getMarkerClasses(context.index),
          context.index == actual ? actualClass:notActualClass,
          nodeClass
        ]
      }),
    }"
    :value="data"
  >

    <template #content="slotProps">
      <slot :item="slotProps.item" :index="slotProps.index"></slot>
    </template>

  </Timeline>
</template>


<script>

import Timeline from 'primevue/timeline';

export default {
  name: "RpmTimeLine",
  components: {
    Timeline,
  },
  data() {
    return {};
  },
  props: {
    data: {
      type: Array,
      default: []
    },
    nodeClass: {
      type: [String, Array],
      default: 'border-theme'
    },
    firstNodeClass: {
      type: [String, Array],
      default: ''
    },
    notFirstNodeClass: {
      type: [String, Array],
      default: ''
    },
    actualfirstNodeClass: {
      type: [String, Array],
      default: ''
    },
    actualNotFirstNodeClass: {
      type: [String, Array],
      default: ''
    },
    lastNodeClass: {
      type: [String, Array],
      default: ''
    },
    actualLastNodeClass: {
      type: [String, Array],
      default: ''
    },
    notActualClass: {
      type: [String, Array],
      default: 'bg-transparent'
    },
    actualClass: {
      type: [String, Array],
      default: 'bg-theme'
    },
    actual: {
      type: [String, Number],
      default: null
    },
  },
  methods: {
    getMarkerClasses(index){
      switch (index) {
        case 0:
          return [
            'rounded',
            this.firstNodeClass,
            index == this.actual ? this.actualfirstNodeClass:''
          ]
        case this.data.length - 1:
          return [
            this.lastNodeClass,
            index == this.actual ? this.actualLastNodeClass:''
          ];
        default:
          return [
            this.notFirstNodeClass,
            index == this.actual ? this.actualNotFirstNodeClass:''
          ];
      }
    }
  },
};
</script>
